import { render, staticRenderFns } from "./BotaoTooltip.vue?vue&type=template&id=b7140d0a&scoped=true"
import script from "./BotaoTooltip.vue?vue&type=script&lang=js"
export * from "./BotaoTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7140d0a",
  null
  
)

export default component.exports